// extracted by mini-css-extract-plugin
export default {"page":"vS","heading":"wS","subheading":"xS","flavorbox":"yS","inner":"zS","image":"AS","label":"BS","flavorselect":"CS","arrow":"ES","flavorswrap":"FS","flavorsheader":"GS","flavorsnav":"HS","flavorsinner":"IS","cancelbtn":"JS","flavorsbottom":"KS","retakebtn":"LS","continueBtn":"MS","drawerinner":"NS","videowrap":"OS","flavorsbottomnav":"PS"};
    if(module.hot) {
      // 1715188238592
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  